/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMapRoute = createReactComponent("map-route", "IconMapRoute", [
  ["path", { d: "M3 7l6 -3l6 3l6 -3v13l-6 3l-6 -3l-6 3v-13", key: "svg-0" }],
  ["path", { d: "M9 12v.01", key: "svg-1" }],
  ["path", { d: "M6 13v.01", key: "svg-2" }],
  ["path", { d: "M17 15l-4 -4", key: "svg-3" }],
  ["path", { d: "M13 15l4 -4", key: "svg-4" }]
]);

export { IconMapRoute as default };
//# sourceMappingURL=IconMapRoute.js.map
